import { node, text } from "~/util/dom";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { store } from "~/state/store";
import { v4 as uuidv4 } from "uuid";
import { createDOMElements } from "~/ui/deepl";
import { ELoginState } from "~/state/user/interfaces";

export interface IReviewDeepLData {
	text: string;
	reviewId: number;
	lang: string;
	container: HTMLElement;
	type: "text" | "reply";
	native: boolean;
}

interface ITranslateData {
	posible: boolean;
	translatedText?: string;
}

interface IResponse {
	code: number;
	message: string;
	text?: string;
	reply?: string;
}

function callRequest(reviewId: number, lang: string) {
	const REQUEST_URL = `${CONFIG.requestUrl}/translate/review/${reviewId}/${lang}`;

	return fetch(REQUEST_URL, {
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
		method: "GET",
	});
}

function translateTexts(reviewId = 0, lang: string): Promise<IResponse> {
	let promise = Promise.reject();

	if (reviewId) {
		// eslint-disable-next-line no-async-promise-executor
		promise = new Promise(async (resolve, reject) => {
			const response = await callRequest(reviewId, lang || Mapy.CUS.userweb.deeplLang || CONFIG.defaultLang);

			if (response.status === 200) {
				const json = await response.json();

				json ? resolve(json) : reject();
			} else {
				reject();
			}
		});
	}

	return promise;
}

function switchTranslate(data: IReviewDeepLData, translateData: ITranslateData, elements: {
	origButton: HTMLButtonElement,
	translateButton: HTMLButtonElement,
	container: HTMLParagraphElement,
 }, orig: boolean, native: boolean) {
	if (data.container) {
		data.container.innerHTML = orig || !translateData.posible || !translateData.translatedText ? data.text : translateData.translatedText;
	}

	elements.origButton.classList[(!orig && native) || (orig && !native) ? "remove" : "add"]("nonactive");
	elements.translateButton.classList[(!orig && native) || (orig && !native) ? "add" : "remove"]("nonactive");
}

export function createDeepLTranslate(data: IReviewDeepLData, type = "", changeCb?: (translate?: boolean) => void): HTMLParagraphElement {
	const { user } = store.getState().user;

	if (user.state === ELoginState.Green) {
		const { container, button, origButton, translateButton } = createDOMElements(data.native);
		const translateData: ITranslateData = {
			posible: data.lang && data.lang !== (Mapy.CUS.userweb.deeplLang || CONFIG.defaultLang),
		};
		const showButton = data.lang !== (Mapy.CUS.userweb.deeplLang || CONFIG.defaultLang);

		if (showButton) {
			button.addEventListener("click", () => {
				const loading = node("span", {}, _("deepl.loading"));

				button.remove();
				container.appendChild(loading);

				const reviewTrans = translateData.posible && data.reviewId ? data.reviewId : 0;
				let haveTranslateText = false;

				translateTexts(reviewTrans, data.native ? undefined : data.lang).then(translatedText => {
					if (translatedText[data.type]) {
						translateData.translatedText = translatedText[data.type];
						haveTranslateText = true;
					}

					switchTranslate(data, translateData, {
						origButton,
						translateButton,
						container,
					}, false, data.native);

					container.innerHTML = "";

					if (haveTranslateText) {
						container.appendChild(translateButton);
						container.appendChild(text(" · "));
						container.appendChild(origButton);

						origButton.addEventListener("click", () => {
							!origButton.classList.contains("nonactive") && switchTranslate(data, translateData, {
								origButton,
								translateButton,
								container,
							}, data.native, data.native);

							changeCb && changeCb();
						}, false);

						translateButton.addEventListener("click", () => {
							!translateButton.classList.contains("nonactive") && switchTranslate(data, translateData, {
								origButton,
								translateButton,
								container,
							}, !data.native, data.native);

							changeCb && changeCb(true);
						}, false);

						changeCb && changeCb(true);
					} else {
						container.appendChild(button);
						container.appendChild(text(" · "));
						container.appendChild(node("i", {}, _("deepl.error")));
					}

					Mapy.getComponent("logger").log("translate", {
						type,
					});
				}, () => {});
			}, false);

			container.appendChild(button);

			return container;
		}
	}

	return null;
}
